<!--
 * @Author: wh
 * @Date: 2020-07-01 17:05:02
 * @LastEditTime: 2022-10-20 17:15:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\retailAccount\retailAccountList.vue
-->
<template>
    <div class="commonTableStyles retailAccountList">
        <van-nav-bar
            left-arrow
            @click-left="onClickLeft"
            @click-right="newRetailAccount"
        >
            <template #title>
                <div
                    :class="{'active': listType == 'lsyw'}"
                    @click="listSwitch('lsyw')"
                >
                    零售业务
                </div>
                <div
                    :class="{'active': listType == 'zcx'}"
                    @click="listSwitch('zcx')"
                >
                    暂存箱
                </div>
            </template>
            <template #right>
                <van-icon name="plus" size="18"></van-icon>
            </template>
        </van-nav-bar>
        <section>
            <div class="search-con" v-if="listType==='lsyw'">
                <van-search
                    placeholder="请输入搜索关键词"
                    v-model="keywords"
                    @search="handleSearch"
                ></van-search>
            </div>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :class="{'zcx': listType==='zcx'}">
                <template v-if="listType==='lsyw'">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                        :immediate-check="false"
                    >
                        <ul class="list">
                            <template v-for="item in retailList">
                                <li :key="item.cvid" @click="toInfo(item.contract_number)" :class="`status${item.contract_status}`">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="state" v-if="item.contract_status===0">未审批</span>
                                            <span class="state" v-else-if="item.contract_status===1">审批中</span>
                                            <span class="state" v-else-if="item.contract_status===2">转换中</span>
                                            <span class="state" v-else-if="item.contract_status===3">变更中</span>
                                            <span class="state" v-else-if="item.contract_status===10">正常</span>
                                            <span class="state" v-else-if="item.contract_status===20">暂停</span>
                                            <span class="state" v-else-if="item.contract_status===30">完成</span>
                                            <span class="state" v-else-if="item.contract_status===40">关闭</span>
                                            <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <span class="info">工程名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">工程地址：{{ item.engineering_location }}</span>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <span class="info">供货站点：{{ item.supply_site_name }}</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <span class="info">方量：{{ item.projected_capacity }}</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                        </div>
                                        <div class="btn-con">
                                            <div class="btn-item btn-item01" @click.stop="setStatus(item)">
                                                <span class="btn-span" v-if="item.contract_status===0">未审批</span>
                                                <span class="btn-span" v-else-if="item.contract_status===1">审批中</span>
                                                <span class="btn-span" v-else-if="item.contract_status===2">转换中</span>
                                                <span class="btn-span" v-else-if="item.contract_status===3">变更中</span>
                                                <span class="btn-span" v-else-if="item.contract_status===10">正常</span>
                                                <span class="btn-span" v-else-if="item.contract_status===20">暂停</span>
                                                <span class="btn-span" v-else-if="item.contract_status===30">完成</span>
                                                <span class="btn-span" v-else-if="item.contract_status===40">关闭</span>
                                            </div>
                                            <div class="btn-item" :class="{'btn-item01': item.contract_status === 10}" @click.stop="copyNew(item)">
                                                <span class="btn-span">复制新增</span>
                                            </div>
                                            <div class="btn-item" @click.stop="placeAnotherOrder(item)" v-if="item.contract_status === 10">
                                                <span class="btn-span">再下订单</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </template>
                <template v-if="listType==='zcx'">
                    <template v-if="retailList.length > 0">
                        <ul class="list">
                            <template v-for="item in retailList">
                                <li :key="item.cvid" @click="modifyRetail(item)">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <span class="info">工程名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">工程地址：{{ item.engineering_location }}</span>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <span class="info">供货站点：{{ item.supply_site_name }}</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <span class="info">方量：{{ item.projected_capacity }}</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </template>
                    <template v-else>
                        <p class="no-data"></p>
                    </template>
                </template>
            </van-pull-refresh>
        </section>
        <van-action-sheet
            v-model="showActionSheet"
            :actions="columns"
            @select="selectConfirm"
            :style="{height: '30%'}"
        ></van-action-sheet>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>
<script>
export default {
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'retail-account-list');
        }
        next();
    },
    name: 'retail-account-list',
    components: {},
    data() {
        return {
            retailList: [],
            stageList: [],
            isUpLoading: false,
            finished: false,
            page: {
                pageindex: 1,
                pagesize: 3,
            },
            total: true,
            currentContractNumber: '', // 当前合同编号
            // 列表类型
            listType: 'lsyw',
            // 供应状态
            showActionSheet: false,
            columns: [
                { name: '正常供应' },
                { name: '暂停供应' },
                { name: '完成供应' },
                { name: '关闭合同' },
            ],
            orignalColumns: [
                { name: '正常供应', value: 10 },
                { name: '暂停供应', value: 20 },
                { name: '完成供应', value: 30 },
                { name: '关闭合同', value: 40 },
            ],
            cvid: '',
            currentContract: {},
            // 下拉刷新
            isLoading: false,
            // 关键词
            keywords: '',
            // 加载层
            showOverlay: false,
            timer: null,
            isRefreash: false,
        };
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 新建业务台账
        newRetailAccount() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newRetailAccount', params: { handleType: 'new', listType: this.listType } });
        },
        // 复制新增
        copyNew(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newRetailAccount', params: { handleType: 'copyNew', contractNumber: item.contract_number } });
        },
        // 再下订单
        placeAnotherOrder(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'placeAnotherOrder', params: { contractNumber: item.contract_number } });
        },
        // 维护
        toMaintain(cvid) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'retailAccountMaintain', params: { cvid: cvid } });
        },
        // 切换列表
        listSwitch(type) {
            this.showOverlay = true;
            this.listType = type;
            this.retailList = [];
            if (this.listType === 'lsyw') {
                this.page.pageindex = 1;
                this.finished = false;
                this.getRetailList();
            } else {
                this.getRetailBaseList();
            }
        },
        // 下拉刷新
        onRefresh() {
            this.isRefreash = true;
            if (this.listType === 'lsyw') {
                this.page.pageindex = 1;
                this.getRetailList();
            } else {
                this.getRetailBaseList();
            }
        },
        // 根据关键词搜索
        handleSearch() {
            this.page.pageindex = 1;
            this.retailList = [];
            this.finished = false;
            this.getRetailList();
        },
        // 拉取零售业务暂存列表
        getRetailBaseList() {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_base_list')
                .then(res => {
                    if (res) {
                        this.retailList = res;
                        this.isLoading = false;
                    }
                    this.showOverlay = false;
                    this.finished = true;
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 分页拉取零售业务台账
        onLoad() {
            this.page.pageindex++;
            this.getRetailList();
        },
        getRetailList() {
            const queryStr = '?keywords=' + this.keywords + '&pageindex=' + this.page.pageindex + '&pageSize=' + this.page.pagesize;
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_page' + queryStr)
                .then(res => {
                    if (res && res.rows.length > 0) {
                        if (this.isRefreash === true) {
                            this.retailList = [];
                            this.retailList = res.rows;
                            this.isRefreash = false;
                            this.total = res.total;
                            if (this.retailList.length === this.total) {
                                this.finished = true;
                            } else {
                                this.finished = false;
                            }
                        } else {
                            this.total = res.total;
                            if (this.retailList.length < 1 ) {
                                this.retailList = res.rows;
                            } else {
                                res.rows.forEach(item => {
                                    this.retailList.push(item);
                                });
                            }
                            if (this.retailList.length === this.total) {
                                this.finished = true;
                            } else {
                                this.finished = false;
                            }
                        }

                    } else {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                    this.$forceUpdate();
                    this.showOverlay = false;
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });

        },
        // 修改零售合同
        modifyRetail(data) {
            const contractNumber = data.contract_number;
            this.$router.isBack = 2;
            this.$router.push({ name: 'newRetailAccount', params: { handleType: 'modify', contractNumber: contractNumber } });
        },
        // 查看合同详情
        toInfo(contractNumber) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'retailAccountInfo', params: { contractNumber: contractNumber } });
        },
        // 设置状态
        setStatus(item) {
            if (item.contract_status === 1) {
                this.$toast('合同审批中不允许修改状态！');
                return;
            }
            this.currentContract = item;
            this.cvid = item.cvid;
            this.showActionSheet = true;
        },
        // 供应状态选择
        selectConfirm(data) {
            const obj = this.orignalColumns.filter(item => item.name === data.name);
            const staus = obj[0].value;
            this.setStausRequest(staus);
            this.showActionSheet = false;
        },
        // 设置状态
        setStausRequest(staus) {
            this.$axios
                .put('/interfaceApi/sale/contract_manager/contract_status/' + this.cvid + '/' + staus)
                .then(res => {
                    if (res) {
                        this.$toast('修改成功！');
                        this.currentContract.staus = staus;
                        this.retailList.forEach(item => {
                            if (item.cvid === this.currentContract.cvid) {
                                item.contract_status = staus;
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
    activated() {},
    created() {
        // this.page.pageindex += 1;
        // this.getRetailList();
        this.page.pageindex = 1;
        this.retailList = [];
        this.showOverlay = true;
        this.keywords = '';
        this.finished = false;
        if (this.listType === 'lsyw' || this.$route.params.isRefresh) {
            this.getRetailList();
        } else {
            this.getRetailBaseList();
        }
    },
};
</script>

<style lang="stylus">
.retailAccountList
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    section
        height calc(100% - 45rpx)
        .van-pull-refresh
            height calc(100% - 44rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .van-pull-refresh__track
                height 100%
        .list
            li
                // 未审批
                &.status0
                    .engineeringInfo_header
                        .state
                            background #0189FC
                // 审批中
                &.status1
                    .state
                        background #FF6600
                // 转换中
                &.status2
                    .engineeringInfo_header
                        .state
                            background #0101B5
                // 变更中
                &.status3
                    .engineeringInfo_header
                        .state
                            background #04A2B9
                // 正常供应
                &.status10
                    .engineeringInfo_header
                        .state
                            background #04B97F
                // 暂停供应
                &.status20
                    .engineeringInfo_header
                        .state
                            background #979EA7
                // 完成供应
                &.status30
                    .engineeringInfo_header
                        .state
                            background #04B97F
                // 完成供应
                &.status40
                    .engineeringInfo_header
                        .state
                            background #E60000
</style>